<template>
	<div class="key-result-body">
		<!-- TODO: is this header necessary at this point? -->
		<header class="key-result-body-header" v-if="$slots.title">
			<h1><slot name="title"></slot></h1>
		</header>
		<div class="key-result-body-south">
			<main class="key-result-body-body">
				<slot name="body"></slot>
			</main>
			<footer class="key-result-body-footer" v-if="$slots.footer">
				<slot name="footer"></slot>
			</footer>
		</div>
	</div>
</template>

<script>
export default {
	name: "KeyResultBody",
};
</script>

<style lang="scss" scoped>
$keyResultBodyTitleColor: $color2-500;

.key-result-body {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 1.5rem;

	padding: 1rem;

	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	width: 100%;

	main {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		gap: 1rem;

		position: relative;
	}

	@include for-size('md') {
		padding: 2rem;
	}
}

.key-result-body-header {
	display: none;

	h1 {
		@include font-and-line-for(1);
		color: $keyResultBodyTitleColor;
		text-align: left;
	}

	@include for-size('md') {
		display: block;
	}
}

.key-result-body-footer {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
}

.key-result-body-south {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 1.5rem;

	flex: 1;

	@include auto-y-scroll();
}
</style>
